import React, { Component } from 'react';
import { withAppContext } from 'context/AppContext';

import BookingcomListingForm from './BookingcomListingForm';

import { getHosts } from '../../../utils/apis/host';
import { getBookingcoms } from '../../../utils/apis/integration';

import { Select, Table, Form, Card, Button, notification, Input, Icon } from 'antd';
import intl from 'react-intl-universal';

const Option = Select.Option;

class BookingcomListing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bookingcoms: [],
      hostMapping: [],
      showModal: false,
      selectedBookingcom: null,
      searchPropertyId: '',
      searchPropertyName: '',
      searchHost: ''
    };
    this.hideModal = this.hideModal.bind(this);
    this.getBookingcomData = this.getBookingcomData.bind(this);
    this.constructColumn = this.constructColumn.bind(this);
    this.refreshIntoEdit = this.refreshIntoEdit.bind(this);
  }

  componentWillMount() {
    this.getBookingcomData();
    getHosts()
      .then(hostRes => {
        if (hostRes && hostRes.status === 200 && hostRes.data) {
          let hostMapping = hostRes.data.map(host => {
            return {
              _id: host._id,
              name: host.name
            };
          });
          let hostOptions = hostRes.data.map(host => {
            return <Option value={host._id}>{host.name}</Option>;
          });
          this.setState({
            hostOptions,
            hostMapping
          });
        } else {
          // console.log('getHost have issues brah');
        }
      })
      .catch(ex => {
        // console.log(ex);
      });
  }

  async refreshIntoEdit(bookingcomPropertyId) {
    let bookingcoms = await this.getBookingcomData().catch(ex => {
      notification.error({
        message: ex
      });
    });
    let bookingcom = bookingcoms.filter(
      bookingcom => bookingcom.bookingcomPropertyId && bookingcom.bookingcomPropertyId.toString() === bookingcomPropertyId.toString()
    )[0];
    if (bookingcom) {
      this.setState({
        selectedBookingcom: bookingcom
      });
      return true;
    } else {
      notification.error({
        message: intl.get('hostConnect.bookingcom.message.refreshError').d('Something wrong whent trying to refresh bookingcom list')
      });
      return false;
    }
  }

  getBookingcomData() {
    return new Promise((resolve, reject) => {
      getBookingcoms()
        .then(res => {
          if (res && res.status === 200) {
            this.setState({
              bookingcoms: res.data
            });
            return resolve(res.data);
          } else {
            return reject('Failed to get bookingcom list');
          }
        })
        .catch(ex => {
          return reject('Failed to get bookingcom list');
        });
    });
  }

  renderBookingcomTitle(bookingcom) {
    return (
      <div>
        {bookingcom.propertyData
          ? bookingcom.propertyData.HotelName || intl.get('hostConnect.bookingcom.headerLabels.noPropertyName').d('No Property Name')
          : intl.get('hostConnect.bookingcom.headerLabels.noProperty').d('No Property')}
      </div>
    );
  }
  renderBookingcomCardContent(bookingcom) {
    return (
      <div>
        {intl.get('hostConnect.bookingcom.headerLabels.hotelId').d('Hotel ID:')} {bookingcom.bookingcomPropertyId}
      </div>
    );
  }

  hideModal = () => {
    this.setState({ showModal: false });
  };

  openForm = bookingcom => e => {
    if (!bookingcom) {
      this.setState({
        selectedBookingcom: null,
        showModal: true
      });
    } else {
      this.setState({
        selectedBookingcom: bookingcom,
        showModal: true
      });
    }
  };

  handleSearch = (selectedKeys, confirm, name) => () => {
    confirm();
    this.setState({ [name]: selectedKeys[0] });
  };

  handleReset = (clearFilters, name) => () => {
    clearFilters();
    this.setState({ [name]: '' });
  };

  constructColumn(isAllowEdit, checkIsAdminReadOnly) {
    const { hostMapping, bookingcoms } = this.state;
    return [
      {
        title: intl.get('hostConnect.bookingcom.tableColumns.bookingID').d('Booking.com Property ID'),
        key: 'bookingcomPropertyId',
        dataIndex: 'bookingcomPropertyId',
        sorter: (a, b) => a.bookingcomPropertyId && b.bookingcomPropertyId && a.bookingcomPropertyId.localeCompare(b.bookingcomPropertyId),
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div className="custom-filter-dropdown">
            <Input
              ref={ele => (this.searchInput = ele)}
              placeholder={intl.get('tables.booking').d('Search Property ID')}
              value={selectedKeys[0]}
              onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
              onPressEnter={this.handleSearch(selectedKeys, confirm)}
              name="searchPropertyId"
            />
            <Button type="primary" onClick={this.handleSearch(selectedKeys, confirm)}>
              {intl.get('tables.search').d('Search')}
            </Button>
            <Button onClick={this.handleReset(clearFilters)}>{intl.get('tables.reset').d('Reset')}</Button>
          </div>
        ),
        filterIcon: filtered => <Icon type="search" style={{ color: filtered ? '#00b9c6' : '#aaa' }} />,
        onFilter: (value, record) => record.bookingcomPropertyId.toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
          if (visible) {
            setTimeout(() => {
              this.searchInput.focus();
            });
          }
        }
      },
      {
        title: intl.get('hostConnect.bookingcom.tableColumns.status').d('Status'),
        key: 'status',
        dataIndex: 'status',
        filters: Array.from(
          new Set(
            bookingcoms.map(item => {
              return item.status.charAt(0).toUpperCase() + item.status.slice(1);
            })
          )
        ).map(item => {
          return { text: intl.get(`hostConnect.ctrip.status.${item}`).d(item), value: item };
        }),
        onFilter: (value, record) => record.status.charAt(0).toUpperCase() === value.charAt(0).toUpperCase(),
        render: (text, record) => {
          return intl
            .get(`hostConnect.ctrip.status.${record.status.charAt(0).toUpperCase() + record.status.slice(1)}`)
            .d(record.status.charAt(0).toUpperCase() + record.status.slice(1));
        }
      },
      {
        title: intl.get('hostConnect.bookingcom.tableColumns.bookingProperty').d('Booking.com Property Name'),
        key: 'propertyData',
        dataIndex: 'propertyData',
        sorter: (a, b) => a.propertyData.hotelName && b.propertyData.hotelName && a.propertyData.hotelName.localeCompare(b.propertyData.hotelName),
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div className="custom-filter-dropdown">
            <Input
              ref={ele => (this.searchInput = ele)}
              placeholder={intl.get('tables.property').d('Search Property Name')}
              value={selectedKeys[0]}
              onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
              onPressEnter={this.handleSearch(selectedKeys, confirm)}
              name="searchPropertyName"
            />
            <Button type="primary" onClick={this.handleSearch(selectedKeys, confirm)}>
              {intl.get('tables.search').d('Search')}
            </Button>
            <Button onClick={this.handleReset(clearFilters)}>{intl.get('tables.reset').d('Reset')}</Button>
          </div>
        ),
        filterIcon: filtered => <Icon type="search" style={{ color: filtered ? '#00b9c6' : '#aaa' }} />,
        onFilter: (value, record) => record.propertyData.HotelName.toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
          if (visible) {
            setTimeout(() => {
              this.searchInput.focus();
            });
          }
        },
        render: propertyData => {
          if (!propertyData) {
            return intl.get('hostConnect.bookingcom.headerLabels.noPropertyData').d('No Property Data');
          }
          if (!propertyData.HotelName) {
            return intl.get('hostConnect.bookingcom.headerLabels.noPropertyName').d('No Property Name');
          }
          return propertyData.HotelName;
        }
      },
      {
        title: intl.get('hostConnect.bookingcom.tableColumns.hpProperty').d('HP Property Name'),
        key: 'property.name',
        dataIndex: 'property',
        sorter: (a, b) => {
          const aName = a.property && a.property.name ? a.property.name : '';
          const bName = b.property && b.property.name ? b.property.name : '';
          return aName.localeCompare(bName);
        },
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div className="custom-filter-dropdown">
            <Input
              ref={ele => (this.searchInput = ele)}
              placeholder={intl.get('tables.hpProperty').d('Search HP Property Name')}
              value={selectedKeys[0]}
              onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
              onPressEnter={this.handleSearch(selectedKeys, confirm)}
              name="searchHpProperty"
            />
            <Button type="primary" onClick={this.handleSearch(selectedKeys, confirm)}>
              {intl.get('tables.search').d('Search')}
            </Button>
            <Button onClick={this.handleReset(clearFilters)}>{intl.get('tables.reset').d('Reset')}</Button>
          </div>
        ),
        filterIcon: filtered => <Icon type="search" style={{ color: filtered ? '#00b9c6' : '#aaa' }} />,
        onFilter: (value, record) => {
          const propertyName = record.property && record.property.name ? record.property.name : '';
          return propertyName.toLowerCase().includes(value.toLowerCase());
        },
        onFilterDropdownVisibleChange: visible => {
          if (visible) {
            setTimeout(() => {
              this.searchInput.focus();
            });
          }
        },
        render: (property, record) => {
          return property && property.name ? property.name : '-';
        }
      },
      {
        title: intl.get('hostConnect.bookingcom.tableColumns.host').d('Host'),
        key: 'host',
        dataIndex: 'host',
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div className="custom-filter-dropdown">
            <Input
              ref={ele => (this.searchInput = ele)}
              placeholder={intl.get('tables.hostName').d('Search Host')}
              value={selectedKeys[0]}
              onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
              onPressEnter={this.handleSearch(selectedKeys, confirm)}
              name="searchHost"
            />
            <Button type="primary" onClick={this.handleSearch(selectedKeys, confirm)}>
              {intl.get('tables.search').d('Search')}
            </Button>
            <Button onClick={this.handleReset(clearFilters)}>{intl.get('tables.reset').d('Reset')}</Button>
          </div>
        ),
        filterIcon: filtered => <Icon type="search" style={{ color: filtered ? '#00b9c6' : '#aaa' }} />,
        onFilter: (value, record) => {
          if (record.host) {
            let hostMap = hostMapping.filter(hostMap => hostMap._id.toString() === record.host.toString())[0];
            return hostMap && hostMap.name && hostMap.name.toLowerCase().includes(value.toLowerCase());
          } else {
            return '';
          }
        },
        onFilterDropdownVisibleChange: visible => {
          if (visible) {
            setTimeout(() => {
              this.searchInput.focus();
            });
          }
        },
        render: (host, record) => {
          if (!host) {
            return intl.get('hostConnect.bookingcom.headerLabels.noHost').d('No Host Assigned');
            // return <Button onClick={this.showSetNickname(record)}>Assign A Host</Button>;
          }
          let hostMap = hostMapping.filter(hostMap => hostMap._id.toString() === host.toString())[0];
          if (hostMap) {
            return hostMap.name;
          } else {
            return host;
          }
        }
      },
      {
        title: intl.get('hostConnect.bookingcom.tableColumns.rooms').d('Booking.com Rooms'),
        key: 'rooms',
        dataIndex: 'rooms',
        sorter: (a, b) => a.rooms.length - b.rooms.length,
        render: (rooms, record) => {
          return rooms ? rooms.length : 0;
        }
      },
      {
        title: intl.get('hostConnect.bookingcom.tableColumns.action').d('Actions'),
        key: 'actions',
        render: (x, record) => {
          return (
            <Button onClick={this.openForm(record)} disabled={!isAllowEdit || checkIsAdminReadOnly()}>
              {intl.get('hostConnect.ctrip.headerLabels.edit').d('Edit')}
            </Button>
          );
        }
      }
    ];
  }

  render() {
    let { showModal, selectedBookingcom, hostOptions } = this.state;
    const { checkIsAllowCreateIntegration, checkIsAllowEditIntegration, checkIsAdminReadOnly } = this.props;

    const isAllowCreate = !!checkIsAllowCreateIntegration();
    const isAllowEdit = !!checkIsAllowEditIntegration();

    return (
      <React.Fragment>
        <BookingcomListingForm
          bookingcom={selectedBookingcom}
          hostOptions={hostOptions}
          visible={showModal}
          hideModal={this.hideModal}
          refreshIntoEdit={this.refreshIntoEdit}
        />
        <Card className="list-card">
          <div className="list-card-control-section">
            <Button type="primary" icon="plus" onClick={this.openForm()} disabled={!isAllowCreate || checkIsAdminReadOnly()}>
              {intl.get('hostConnect.bookingcom.headerLabels.new').d('New Booking.com')}
            </Button>
          </div>
          <Table
            columns={this.constructColumn(isAllowEdit, checkIsAdminReadOnly)}
            dataSource={this.state.bookingcoms.filter(bookingcom => bookingcom.bookingcomPropertyId)}
          />
        </Card>
      </React.Fragment>
    );
  }
}

export default Form.create()(withAppContext(BookingcomListing));
